import { Injectable } from '@angular/core';
import { parseJWT } from '@approot/utilities';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { AuthService, UserSession } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard {
  constructor(private authService: AuthService) {}
  public canActivate(): Observable<boolean> {
    return this.authService.currentSession$().pipe(
      take(1),
      map((session: UserSession) => {
        const token = parseJWT(session.getIdToken().getJwtToken());
        return token['custom:isSuperuser'] === 'true';
      }),
      catchError((err: Error) => {
        console.error(err);
        return of(false);
      })
    );
  }
}
